
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Document from '@/extend/classes/Document';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeDocument' })

export default class storeDocument extends VuexModule {
  // States
  private reccords: Document[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get documentLoading (): boolean {
    return this.dataLoading;
  }
  private get documentRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get documentLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewDocument() {
    return (): Document => { 
      return this.getDocument(0, true);
    }
  }

  
  public get getDocument () {
    return (id: number, canCreate = false): Document => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Document can't be 0")
        return new Document();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Document();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Document.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromDocument(data.reccords[0] as Document);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listDocument (): Document[] {
    return this.reccords;
  }

  public get listConfigDocument (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mDocumentRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mDocumentClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mDocumentLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mDocumentLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Document.fromJson(reccord as Document));
    })
    Document.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mDocumentConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mDocumentCreated (obj: Document): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareDocument(obj)) {
          api.fromDocument(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareDocument(obj)) {
            api.fromDocument(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mDocumentUpdated (obj: Document): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareDocument(obj)) {
          api.fromDocument(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mDocumentDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerDocument (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.documentRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerDocument(this.documentCreated, this.documentUpdated, this.documentDeleted);
          this.mDocumentRegistered();
        } else {
          setTimeout(() => resolve(this.registerDocument(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.documentLoading && !this.documentLoaded) {
          this.mDocumentLoading(true);
          return Document.list(filter)
            .then((data: ListData) => {
              this.mDocumentLoaded(data);
              this.mDocumentLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredDocument (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.documentLoading) {
        this.mDocumentLoading(true);
        return Document.list(filter)
          .then((data: ListData) => {
            this.mDocumentLoaded(data);
            this.mDocumentLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createDocument (obj: Document): Promise<Document> {
    return new Promise((resolve, reject) => {
      return Document.fromJson(obj).createForStoreDocument()
        .then((reccords) => {
          this.mDocumentCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public deleteDocument (obj: Document): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Document.fromJson(obj).deleteForStoreDocument()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mDocumentDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private documentCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mDocumentConfigUpdated(config)
    const obj = objConfig.obj as Document;
    this.mDocumentCreated(Document.fromJson(obj));
  }

  @Action
  private documentUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mDocumentConfigUpdated(config)
    const obj = objConfig.obj as Document;
    this.mDocumentUpdated(Document.fromJson(obj));
  }

  @Action
  private documentDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Document;
    this.mDocumentDeleted(obj.id);
  }
}
